import {
  ACTION_LABELS,
  describeActor,
  isDestructive,
  visibleChanges,
} from 'helper/timeSheetEventLabels';

const formatTime = (value) => {
  if (!value) return '';
  return new Date(value).toLocaleTimeString('fr-FR', {
    hour: '2-digit',
    minute: '2-digit',
  });
};

const ChangeRow = ({ change, muted }) => (
  <div
    className={`flex flex-wrap items-baseline gap-2 ft-sm ${
      muted ? 'text-gray-400' : 'text-gray-900'
    }`}
  >
    {change.text ? (
      <span className={muted ? '' : 'font-medium'}>{change.text}</span>
    ) : (
      <>
        <span className={muted ? '' : 'font-medium'}>{change.label}</span>
        {change.isCreation ? (
          <span className={muted ? '' : 'font-medium'}>{change.after}</span>
        ) : (
          <>
            <span className="text-gray-400 line-through">{change.before}</span>
            <span aria-hidden="true" className="text-gray-300">
              →
            </span>
            {change.isRemoval ? (
              <span className={muted ? '' : 'font-medium'}>retiré</span>
            ) : (
              <span className={muted ? '' : 'font-medium'}>{change.after}</span>
            )}
          </>
        )}
      </>
    )}
  </div>
);

const TimeSheetHistoryEntry = ({ event }) => {
  const { decided, derived } = visibleChanges(event);
  const destructive = isDestructive(event);
  const replacedId = event?.replaces?.id_time_sheet;

  return (
    <div className="flex gap-4 py-3">
      <div className="w-12 shrink-0 ft-sm text-gray-400 tabular-nums">
        {formatTime(event?.createdAt)}
      </div>
      <div className="flex flex-col gap-1 min-w-0">
        <div className="ft-sm text-gray-500 truncate">{describeActor(event)}</div>
        <div
          className={`ft-sm font-medium ${
            destructive ? 'text-amber-700' : 'text-gray-900'
          }`}
        >
          {ACTION_LABELS[event?.action] || event?.action}
        </div>

        {replacedId ? (
          <div className="ft-sm text-amber-700">
            Ce relevé remplace le relevé n°{replacedId}
          </div>
        ) : null}

        {decided.map((change, i) => (
          <ChangeRow key={`d-${i}`} change={change} />
        ))}
        {derived.map((change, i) => (
          <ChangeRow key={`r-${i}`} change={change} muted />
        ))}

        {decided.length === 0 && derived.length === 0 && !replacedId ? (
          <div className="ft-sm text-gray-400">Aucune valeur modifiée</div>
        ) : null}
      </div>
    </div>
  );
};

export default TimeSheetHistoryEntry;
